const initialState = {
  logged: false,
  loginPending: false,
  logoutPending: false,
  loginError: false,
  loginErrors: [],
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case 'HANDLE_LOGIN_PENDING':
    case 'FETCH_CREDENTIALS_PENDING': {
      return {
        ...state,
        logged: false,
        loginPending: true,
        logoutPending: false,
        loginError: false,
        loginErrors: [],
      };
    }

    case 'HANDLE_LOGIN_REJECTED':
    case 'FETCH_CREDENTIALS_REJECTED': {
      // this action should never happen (FETCH_CREDENTIALS_REJECTED)
      return {
        ...state,
        logged: false,
        loginPending: false,
        logoutPending: false,
        loginError: true,
        loginErrors: action.payload.response && action.payload.response.data,
      };
    }

    /* we fetch the credentials after the website was reloaded */
    /* we also get user data after the user logged in */
    case 'HANDLE_LOGIN_FULFILLED':
    case 'FETCH_CREDENTIALS_FULFILLED': {
      if (!action.payload.data) {
        return {
          ...state,
          logged: false,
          loginPending: false,
          logoutPending: false,
          loginError: false,
          loginErrors: [],
        };
      }

      return {
        ...state,
        ...action.payload.data,
        logged: true,
        loginPending: false,
        logoutPending: false,
        loginError: false,
        loginErrors: [],
      };
    }

    case 'HANDLE_LOGOUT_PENDING': {
      return {
        ...state,
        logged: false,
        loginPending: false,
        logoutPending: true,
        loginError: false,
        loginErrors: [],
      };
    }

    case 'HANDLE_LOGOUT_REJECTED': {
      break;
    }

    case 'HANDLE_LOGOUT_FULFILLED': {
      return { ...initialState };
    }

    case 'OAUTH_ERROR': {
      return {
        ...state,
        loginError: true,
        loginErrors: [action.payload.error],
      };
    }

    case 'FORM_FINISHED': {
      if (action.payload.formName === 'profileEdit') {
        return { ...state, ...action.payload.response.data };
      }
      if (action.payload.formName === 'forgotPasswordReset') {
        return { ...state, ...action.payload.response.data, logged: true };
      }
      if (action.payload.formName === 'checkoutSignupForm') {
        return { ...state, ...action.payload.response.data, logged: true };
      }
      break;
    }

    case 'UPLOAD_FILE_FINISHED': {
      if (
        action.payload.response &&
        action.payload.response.data &&
        action.payload.response.data !== undefined &&
        action.payload.response.data.email !== undefined &&
        state.profile.id === action.payload.response.data.id
      ) {
        const newState = { ...state };
        newState.profile = action.payload.response.data;

        return newState;
      }
      break;
    }

    case 'STORE_DEVICE_TOKEN': {
      if (action.payload) {
        return { ...state, deviceToken: action.payload };
      }
      break;
    }

    case 'STORE_VOIP_DEVICE_TOKEN': {
      if (action.payload) {
        return { ...state, voipDeviceToken: action.payload };
      }
      break;
    }
  }

  if (action.type.indexOf('REJECTED') !== -1) {
    if (action.payload && action.payload.response && action.payload.response.status === 403) {
      return {
        ...state,
        logged: false,
        loginPending: false,
        logoutPending: false,
        loginError: false,
        loginErrors: [],
      };
    }
  }

  return state;
}
